// import React from "react";
// import { Box } from "@mui/material";
// import {
//   MenuBookOutlined,
//   SchoolOutlined,
//   SupportAgentOutlined,
// } from "@mui/icons-material";
// import AppActionCard from "../../../components/AppActionCard";
// import {
//   MESSAGES,
//   warningColor,
//   accentColor,
//   infoColor,
//   ROUTES,
// } from "../../../constants/consts";
// import { useNavigate } from "react-router-dom";

// export default function ActionGrid() {
//   const navigate = useNavigate();

//   return (
//     <Box
//       sx={{
//         display: "grid",
//         gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
//         gap: 2,
//       }}
//     >
//       <AppActionCard
//         icon={SupportAgentOutlined}
//         title={MESSAGES.ACTION_SUPPORT}
//         subtitle={MESSAGES.ACTION_SUPPORT_SUB}
//         accentColor={warningColor}
//         onTap={() => navigate(ROUTES.CUSTOMER_SUPPORT)}
//       />
//       <AppActionCard
//         icon={SchoolOutlined}
//         title={MESSAGES.ACTION_EDU}
//         subtitle={MESSAGES.ACTION_EDU_SUB}
//         accentColor={accentColor}
//         onTap={() => navigate(ROUTES.CUSTOMER_EDU)}
//       />
//       <AppActionCard
//         icon={MenuBookOutlined}
//         title={MESSAGES.ACTION_INFO}
//         subtitle={MESSAGES.ACTION_INFO_SUB}
//         accentColor={infoColor}
//         onTap={() => navigate(ROUTES.CUSTOMER_INFO)}
//       />
//     </Box>
//   );
// }
import React from "react";
import { Box } from "@mui/material";
import { keyframes } from "@mui/system"; // ← EKLE
import {
  MenuBookOutlined,
  SchoolOutlined,
  SupportAgentOutlined,
} from "@mui/icons-material";
import AppActionCard from "../../../components/AppActionCard";
import {
  MESSAGES,
  warningColor,
  accentColor,
  infoColor,
  ROUTES,
} from "../../../constants/consts";
import { useNavigate } from "react-router-dom";

const fadeInUp = keyframes`
  from { opacity: 0; transform: translateY(24px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const cardAnim = (delay) => ({
  animation: `${fadeInUp} 0.5s cubic-bezier(0.22, 1, 0.36, 1) ${delay}s backwards`,
});

export default function ActionGrid() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
        gap: 2,
      }}
    >
      <Box sx={cardAnim(0.45)}>
        <AppActionCard
          icon={SupportAgentOutlined}
          title={MESSAGES.ACTION_SUPPORT}
          subtitle={MESSAGES.ACTION_SUPPORT_SUB}
          accentColor={warningColor}
          onTap={() => navigate(ROUTES.CUSTOMER_SUPPORT)}
        />
      </Box>

      <Box sx={cardAnim(0.55)}>
        <AppActionCard
          icon={SchoolOutlined}
          title={MESSAGES.ACTION_EDU}
          subtitle={MESSAGES.ACTION_EDU_SUB}
          accentColor={accentColor}
          onTap={() => navigate(ROUTES.CUSTOMER_EDU)}
        />
      </Box>

      <Box sx={cardAnim(0.65)}>
        <AppActionCard
          icon={MenuBookOutlined}
          title={MESSAGES.ACTION_INFO}
          subtitle={MESSAGES.ACTION_INFO_SUB}
          accentColor={infoColor}
          onTap={() => navigate(ROUTES.CUSTOMER_INFO)}
        />
      </Box>
    </Box>
  );
}
